import { AxiosError } from 'axios';
import { isEmpty, isError } from 'lodash';

/**
 * Check if the specified value is an instance of AxiosError object
 *
 * @param {*} value Value to check
 */
export const isAxiosError = (value: any): value is AxiosError => {
  if (isEmpty(value) || !isError(value)) {
    return false;
  }

  return 'isAxiosError' in value && (value as AxiosError).isAxiosError;
};

export * from './CredentialsReadError';
export * from './EntityIdentifierError';
export * from './RefreshTokenReadError';
export * from './TokenExpiredError';
export * from './TokenReadError';
export * from './UnauthorizedError';
